import React, { useState } from 'react'
import { cellRendererCheck, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import HoverImage from "react-hover-image/build";
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import { Button } from 'reactstrap';
import Drawer from 'components/Drawer';
import plus from "assets/icon/plus-icon.svg";
import AddCrossWalkDrawer from '../AddCrosswalk';
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';
import CellOptions from 'components/reactStrapTable/components/CellOptions';
import moment from 'moment';
import Smallspinlogo from "assets/images/upload.gif";
import { ModuleAccess } from 'utils/moduleaccess';


let rowForEdit = {};

const MappingHistory = (props) => {

  const API = useAxios();
  const { setNDCMapingHistoryData,
    loading,
    orgId,
    setLoading,
    ndcmapingHistoryData, crosswalkNdcsearch, ndcDetails, ishiddenflag, setIshiddenflag,storedDate} = props;
  debugger;
  const [addmapings, setAddMapings] = useState(false);
  const [showWarning, setShowWarning] = useState('');
  const [originalData, setOriginalData] = useState({});
  // const [ishiddenflag, setIshiddenflag] = useState(false);
  const handelAddMaping = () => {
    setAddMapings(!addmapings);
  };
  const handelClickimage = () => {
    setChargeCodeflag(false)
  };
  const renderspin = (rowData) => {

    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        // onClick={()=>togglemapingview(rowData)}
        title="Reprocessing in progress"
        hidden={rowData.reProcessedFlag == "N"}
      >
        <HoverImage
          key="Maping"
          src={Smallspinlogo}
          hoverSrc={Smallspinlogo}
          alt=""
        />
      </Button>
    );
  };
  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit1(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "chargeCode",
      text: "Charge Code",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.chargeCode),
    },
    {
      dataField: "chargeDescription",
      text: "Charge Code Description",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.chargeDescription),
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: false,
      width: 180,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },

    {
      dataField: "startDate",
      text: "Effective Date",
      sort: false,
      width: 160,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    {
      dataField: "endDate",
      text: "Term Date",
      sort: false,
      width: 200,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    // {
    //   dataField: "bupp",
    //   text: "Last Invoice Date",
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   inputType: "date",
    //   edit: false,
    //   hideColFilter: false,
    //   cellRenderer: (row, col) => cellRendererCheck("07-21-2025"),
    // },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: false,
      width: 160,
      show: true,
      inputType: "date",
      edit: false,
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    },
  ];
  const fetchmapingHistory = async (rowData) => {
    debugger;
    let ndc = rowData?.ndc
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId?.tenantID}/Crosswalk/NdcMappingHistory/${ndc}`, crosswalkNdcsearch,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setNDCMapingHistoryData(data.items);
        setLoading(false);
      }
      else {
        setNDCMapingHistoryData([]);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  }
  const editRow = (rowData, isEdit = true) => {
    debugger;
    setShowWarning('');
    if (isEdit == false) {
      setIshiddenflag(false);
    }
    let tempData = [...ndcmapingHistoryData];
    if (isEdit) {
      let formattedRowData = { ...rowData };
      if (rowData.startDate) {
        const date = dateFormate(rowData.startDate);
        formattedRowData.startDate = date;
      }
      if (rowData.endDate) {
        const date = dateFormate(rowData.endDate);
        formattedRowData.endDate = date;
      }
      setOriginalData(formattedRowData);
    }
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.chargeDrugID === rowData?.chargeDrugID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;

    });
    setNDCMapingHistoryData(tempData);
  };

  const cellRenderEdit = (row) => {
    if (hasPermission("ED"))
      return <CellOptions row={row} onEdit={editRow} onSave={saveUpdateRow} setIshiddenflag={setIshiddenflag} ishiddenflag={ishiddenflag} />;
  };
  const hasPermission = (code) => {
    return ModuleAccess("CRW", code);
  };
  const cellRenderEdit1 = (rowData) => {
    if (hasPermission('ED'))

      return (
        <div className="d-flex align-items-center">
          {cellRenderEdit(rowData)}
          {renderspin(rowData)}

        </div>
      );
  };

  const isEqual = (a, b) => {
    const normalize = val => (val === null || val === undefined || val === "") ? "" : val;
    return normalize(a).toString() === normalize(b).toString();
  };

  const updateRowValue = (value, col) => {
    debugger;
    if (col === 'endDate' && value !== "") {
      setShowWarning('');
    }
    const tempRow = { ...rowForEdit };

    if (rowForEdit.startDate) {
      tempRow.startDate = dateFormate(rowForEdit.startDate);
    }
    if (rowForEdit.endDate) {
      tempRow.endDate = dateFormate(rowForEdit.endDate);
    }

    tempRow[col] = value;

    const isSame =
      isEqual(originalData.startDate, tempRow.startDate) &&
      isEqual(originalData.endDate, tempRow.endDate);

    setIshiddenflag(!isSame);
    rowForEdit = tempRow;
  };
  const saveUpdateRow = async () => {
    debugger;

    let payload = { ...rowForEdit };
    payload.startDate = payload.startDate != null ? dateFormate(payload.startDate) : null;
    payload.endDate = payload.endDate != null ? dateFormate(payload.endDate) : null;
    
    if (payload.endDate && new Date(payload.endDate) < new Date(payload.startDate)) {
      return setShowWarning('Term Date must be Greater Than or Equal to EffectiveDate');
    }
    setLoading(true)
    if (payload.endDate !== null) {
      payload.endDate = moment(payload.endDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
    }
    payload.startDate = moment(payload.startDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
    delete payload.isEdit;
    try {
      const result = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/UpdateMappingHistory`,
        payload,
        {
          hasDefaultURL: true,
        }
      );

      if (result.data == true) {
        toast.success('updated successfully');
        fetchmapingHistory(payload)
        // Crosswalkrefetc(true);
        // setLoading(false);
      }
      else {
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    if (formatterType == "date") {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          //hasTouched={hasTouched}
          showWarning={showWarning}
          endDateFormatter={true}
          alwaysEditableCheckbox={alwaysEditableCheckbox}

        />
      );

    }

    else {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
        // alwaysEditableCheckbox={alwaysEditableCheckbox}
        />
      );
    }
  };
  return (
    <div>

      <div className='d-flex'>
        <h3 className='f-16 font-weight-600' style={{ color: "#702C62" }}>Crosswalk Mappings

        </h3>
        <Button size='sm'
          color='primary'
          className='ms-auto upload_btn'
          // style={{marginRight:"10px",padding:"2px 8px"}}
          // hidden={(!(hasPermission2('UP')) && add == "Upload") || (!hasPermission('AD') && add == "Add")} 

          onClick={handelAddMaping}

        > <span className="" style={{ paddingRight: "4px", position: "relative", top: "-1px", }}><img src={plus} alt="" /></span>
          Add
        </Button>
      </div>
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={ndcmapingHistoryData?.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="crosswalkmaping"
          height={550}
          fixedColumn
          width={1200}
          //   hasPagination
          // reset={reset}
          data={ndcmapingHistoryData}
          columns={mainCol}
          // buttononclick={handelAddMaping}
          //   filters={[]}
          //   totalRecords={10}
          display={true}
          hidefilter={true}
          pageSize={1}
          //  add={"Add"}
          //   currentPage={1}


          showtoggle={false}

        />

      </div>
      <Drawer
        direction="end"
        isOpen={addmapings}
        toggle={handelAddMaping}
        size="md"
        title="New Mapping"
      >
        <AddCrossWalkDrawer loading={loading} setNDCMapingHistoryData={setNDCMapingHistoryData} handelAddMaping={handelAddMaping} setLoading={setLoading} orgId={orgId} crosswalkNdcsearch={crosswalkNdcsearch} ndcDetails={ndcDetails} storedDate={storedDate} />

      </Drawer>
    </div>
  )
}

export default MappingHistory